import { render, staticRenderFns } from "./DeliveryEditObservationDialog.vue?vue&type=template&id=1aca4c1e"
import script from "./DeliveryEditObservationDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryEditObservationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports